import { useAppDispatch } from 'app/store';
import useReactWebSocket, { ReadyState } from 'react-use-websocket';
import { useEffect, useMemo } from 'react';
import { setSubscriptionResource } from 'app/store/WebSockets/slice';
import { useWebSocketConnectionLink } from 'app/utils/hooks/webSockets/useWebSocketConnectionLink';

export const useSongRoomWebSocket = ({ songGuid }: { songGuid: string }) => {
  const dispatch = useAppDispatch();
  const { connectionUrl } = useWebSocketConnectionLink();

  const { readyState, sendJsonMessage } = useReactWebSocket(connectionUrl, {
    share: true,
  });

  const setSubscription = useMemo(
    () => (subscriptionResource: string | null) => {
      sendJsonMessage({
        type: 'Subscribe',
        payload: { subscriptionResource },
      });
    },
    [sendJsonMessage]
  );

  useEffect(() => {
    if (readyState === ReadyState.OPEN && songGuid) {
      setSubscription(songGuid);
    }
  }, [setSubscription, songGuid, readyState]);

  useEffect(
    () =>
      function cleanup() {
        setSubscription(null);
        dispatch(setSubscriptionResource({ subscriptionResource: undefined }));
      },
    [dispatch, setSubscription]
  );
};
